import React from 'react';
import { Checkbox as BO_Checkbox, TextButton as BO_TextButton, } from '@wix/design-system';
import { Checkbox, Text, TextButton, TextTypography } from 'wix-ui-tpa';
import { SET_IS_HIDDEN_FOLDER } from '../EntityAdvancedPermissionsState';
import { classes } from './HideFolderCheckbox.st.css';
const HideFolderCheckbox = (props) => {
    const { isDashboard, advancedPermissionState, setAdvancedPermissionState, checkboxLabel, checkboxLearnMore, locale, triggerBiEventHiddenCheckboxClick, isExperimentOn, } = props;
    const handleHideFolderCheckBox = () => {
        const value = !advancedPermissionState.isHidden;
        setAdvancedPermissionState({
            type: SET_IS_HIDDEN_FOLDER,
            isHidden: value,
        });
        triggerBiEventHiddenCheckboxClick &&
            triggerBiEventHiddenCheckboxClick(value);
    };
    return (React.createElement(React.Fragment, null, isDashboard ? (React.createElement(BO_Checkbox, { size: "small", onChange: handleHideFolderCheckBox, checked: advancedPermissionState.isHidden },
        checkboxLabel,
        React.createElement(BO_TextButton, { size: "small", as: "a", target: "_blank", href: `https://support.wix.com/${locale}/article/wix-file-share-hiding-a-private-folder` }, checkboxLearnMore))) : (isExperimentOn ? (React.createElement(Checkbox, { label: React.createElement(Text, { typography: TextTypography.runningText, className: classes.checkBoxText },
            checkboxLabel,
            React.createElement(TextButton, { className: classes.checkBoxText, as: "a", onClick: () => window.open(`https://support.wix.com/${locale}/article/wix-file-share-hiding-a-private-folder`, '_blank') }, checkboxLearnMore)), onChange: handleHideFolderCheckBox, checked: advancedPermissionState.isHidden })) : (React.createElement(React.Fragment, null)))));
};
export default HideFolderCheckbox;
//# sourceMappingURL=HideFolderCheckbox.js.map